import { render, staticRenderFns } from "./receipts.vue?vue&type=template&id=2820dbac&scoped=true"
import script from "./receipts.vue?vue&type=script&lang=js"
export * from "./receipts.vue?vue&type=script&lang=js"
import style0 from "./receipts.vue?vue&type=style&index=0&id=2820dbac&prod&scoped=true&lang=scss"
import style1 from "./receipts.vue?vue&type=style&index=1&id=2820dbac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2820dbac",
  null
  
)

export default component.exports